// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 //  The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  "isPaymentHit": false,
  isAllowedCancellation:true,
  defaultGateway:"PAYU",
  mobileNo:"+91 9971270406",
  emailId:"info@ramdasinfotech.com",
 
  "AppRedirectURLFlight": "https://b2b.travelportal24.com/flight-payment",
  "AppRedirectURLHotel": "https://b2b.travelportal24.com/hotel-payment",
  "AppRedirectURLSightseeing": "https://b2b.travelportal24.com/sightseeing/sightseeing-payment",
  "AppRedirectURLHoliday": "http://localhost:4200/holiday/holiday-payment",
  /*"AppRedirectURLHoliday": "https://b2b.travelportal24.com/holiday/holiday-payment",*/
  "AppRedirectURLTransfer": "https://b2b.travelportal24.com/transfer/transfer-payment",
  
  /*UtilityBaseURL: 'http://localhost:64585/',
   GenericBaseURL: 'http://localhost:51524/',*/
  UtilityBaseURL: 'https://SriUtilityApi.travelportal24.com/',
  GenericBaseURL: 'https://SriGenericApi.travelportal24.com/',
 
  PaymentInitiateURL: 'https://payment.travelportal24.com/PaymentSrv.asmx/PaymentInitiate',
  PaymentURL: "https://payment.travelportal24.com/API/PaymentWaiting.aspx?PG=",
  HotelBaseURL: 'https://SriHotelApi.travelportal24.com/',
  FlightBaseURL: 'https://SriFlightApi.travelportal24.com/',
  /*FlightBaseURL: 'https://betaapi.sourcemytrip.co/Beta_FlightAPI/',*/
  PackageBaseURL: 'https://SriPackageApi.travelportal24.com/',
  SightseeingBaseURL: 'https://SriSeightseeingApi.travelportal24.com/',
  TransferBaseURL: 'https://SriTransferApi.travelportal24.com/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
